export const SITEWIDE_NOTIFICATION_SLUG = 'defaultNotificationBanner'

export const MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE = 5
